import { render, staticRenderFns } from "./StockForm.vue?vue&type=template&id=072b50ad&lang=pug&"
import script from "./StockForm.vue?vue&type=script&lang=js&"
export * from "./StockForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports